'use client'

import classNames from 'clsx'
import type { ReactNode } from 'react'

import ArrowDown from '@/assets/icons/leaderboard/lb-arrow-down-20.svg'
import ArrowUp from '@/assets/icons/leaderboard/lb-arrow-up-20.svg'

import S from './MyRankPill.module.scss'

export type MyRankDirection = 'up' | 'down'

type MyRankPillProps = {
  direction: MyRankDirection
  visual: ReactNode
  label: string
  rank: number
  value: string
  unit?: string
  jumpLabel: string
  onJump: () => void
}

/** Floating "Your rank" control (Figma "LB Floating / My rank"). */
export function MyRankPill({
  direction,
  visual,
  label,
  rank,
  value,
  unit,
  jumpLabel,
  onJump
}: MyRankPillProps) {
  const Arrow = direction === 'up' ? ArrowUp : ArrowDown
  return (
    <button
      type="button"
      className={classNames(S.pill, direction === 'up' && S.pillUp)}
      onClick={onJump}
      aria-label={jumpLabel}
    >
      <span className={S.visual}>{visual}</span>
      <span className={S.label}>{label}</span>
      <span className={S.rank}>#{rank}</span>
      <span className={S.divider} aria-hidden />
      <span className={S.value}>{value}</span>
      {unit ? <span className={S.unit}>{unit}</span> : null}
      <span className={S.jump} aria-hidden>
        <Arrow className={S.arrow} />
      </span>
    </button>
  )
}
